import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=6c8e1a40&scoped=true"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=6c8e1a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e1a40",
  null
  
)

export default component.exports